<span class="bold">Review Submitted</span>
<div class="bar">
    <div class="login-bar"></div>
</div>

<div class="submit-response">Thank you for submitting more information about your claim! Please give us time to review this information.</div>